import { Directive, EventEmitter, Output, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[outsideClick]'
})
export class OutsideClickDirective {
  constructor(private host: ElementRef) { }

  @Output()
  public onOutsideClick: EventEmitter<any> = new EventEmitter();
  /** true - To disable onOutsideClick event
   * or class name of container where onOutsideClick should not fire */
  @Input('outsideClickDisable')
  public outsideClickDisable: boolean | string;

  @HostListener('document:mousedown', ['$event'])
  onClick($event) {

    if (this.outsideClickDisable === true) {
      return;
    }

    let target = $event.target;
    while (target) {
      if (this.host.nativeElement !== target) {
        if (this.hasClass(target, <string>this.outsideClickDisable)) {
          break;
        }
        target = (<any>target).parentElement;
      } else {
        break;
      }
    }
    if (!target) {
      this.onOutsideClick.emit();
    }
  }

  private hasClass(element: any, className: string): any {
    const hasClassName = element.classList.contains(className);
    return hasClassName;
  }
}
